// extracted by mini-css-extract-plugin
export default {"body":"RestoreEmailSent_body__NgH2k","title":"RestoreEmailSent_title__AYIQw","subtitle":"RestoreEmailSent_subtitle__gasQ5"};